import React, {useMemo, useState, useEffect} from 'react';
import { Slider } from 'antd';
import type { SliderMarks } from 'antd/es/slider';
import { RangeSelectorWrapper } from '../styles';
import {StyledParagraph} from "../../CustomAntdComponents/Typography";

type Props = {
    onChange: (arg: [number, number]) => void,
    farePriceRange: PriceRangeType,
    value?: [number, number] | null,
}
function PriceRange({ onChange, farePriceRange, value }: Props) {
    const { min, max } = farePriceRange;
    const currentValue = value || [min, max];
    const [minValue, setMinValue] = useState(currentValue[0]);
    const [maxValue, setMaxValue] = useState(currentValue[1]);

    useEffect(() => {
        const val = value || [min, max];
        setMinValue(val[0]);
        setMaxValue(val[1]);
    }, [value, min, max]);

    const marks: SliderMarks = {
        [min]: `N${min.toLocaleString()}`,
        [max]: `N${max.toLocaleString()}`,
  };

  const handlePriceFilter = (value: number | [number, number]) => {
      const val = value as [number, number];
      setMinValue(val[0]);
      setMaxValue(val[1]);
      onChange(val);
  };

  const noRange = useMemo(() => min === max, [min, max]);
   const auth = localStorage.getItem("trips_auth");
  const userData: UserAuth = JSON.parse(auth || "{}");
  

  return (
    <>
        <StyledParagraph color='primary' size="normal">
            {noRange ? `${userData?.ExtraData?.CurrencyCode || ""}${minValue.toLocaleString()}` : `${userData?.ExtraData?.CurrencyCode || ""}${minValue.toLocaleString()} - ${userData?.ExtraData?.CurrencyCode || ""}${maxValue.toLocaleString()}`}
        </StyledParagraph>
        {
            !noRange && (
                <RangeSelectorWrapper>
                    <Slider
                        range
                        tooltip={{
                            formatter: (value) => `${userData?.ExtraData?.CurrencyCode || ""}${value?.toLocaleString() || ""}`
                        }}
                        marks={marks}
                        value={currentValue}
                        min={min}
                        max={max}
                        onChange={handlePriceFilter}
                    />
                </RangeSelectorWrapper>
            )
        }
    </>
  );
}

export default PriceRange;
